import {
    GET_ENCODE_CONFIG_SETTINGS_START,
    GET_ENCODE_CONFIG_SETTINGS_SUCCESS,
    GET_ENCODE_CONFIG_SETTINGS_ERROR
} from '../constants';

export default function encodeConfigSettings(state = {}, action) {
    switch (action.type) {

        case GET_ENCODE_CONFIG_SETTINGS_START:
            return {
                ...state,
            };

        case GET_ENCODE_CONFIG_SETTINGS_SUCCESS:
            return {
                ...state,
                ...action?.encodeConfigSettings,
            };

        case GET_ENCODE_CONFIG_SETTINGS_ERROR:
            return {
                ...state,
            };

        default:
            return {
                ...state,
            };
    }
}
